export enum TransactionRoutes {
  index = 'transaction-index',
  home = 'transaction-home'
}
